export default __webpack_public_path__ + "static/media/c.23c729d4.png";